import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth, Role } from './AuthContext';
import { ForbiddenPage } from '../../app/pages/ForbiddenPage';

export interface RoutePermissionGuardProps {
  permission?: string;
  allowedRoles?: Role[];
  suiteId?: string;
  moduleId?: string;
  redirectTo?: string;
  children?: React.ReactNode;
}

export const RoutePermissionGuard: React.FC<RoutePermissionGuardProps> = ({
  permission,
  allowedRoles,
  suiteId,
  moduleId,
  redirectTo,
  children,
}) => {
  const { role, hasPermission, hasSuite, hasModule } = useAuth();

  if (suiteId && !hasSuite(suiteId)) {
    return redirectTo ? <Navigate to={redirectTo} replace /> : <ForbiddenPage />;
  }

  if (suiteId && moduleId && !hasModule(suiteId, moduleId)) {
    return redirectTo ? <Navigate to={redirectTo} replace /> : <ForbiddenPage />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return redirectTo ? <Navigate to={redirectTo} replace /> : <ForbiddenPage />;
  }

  if (permission && !hasPermission(permission)) {
    return redirectTo ? <Navigate to={redirectTo} replace /> : <ForbiddenPage />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default RoutePermissionGuard;
